// Import necessary dependencies
import axios from 'axios';
import UAParser from 'ua-parser-js';

const setIsSafari = (userAgentInfo) => {
  const isSafari = userAgentInfo.browser.name === 'Safari';

  if (isSafari) {
    document.body.classList.add('safari');
  }
};

function setCustomHeaders() {
  const parser = new UAParser();
  const userAgentInfo = parser.setUA(navigator.userAgent).getResult();
  const customOSNames = {
    iOS: 'ios',
    Android: 'android',
    Windows: 'windows',
    Linux: 'linux',
    'Mac OS': 'macos',
  };

  const operatingSystem = customOSNames[userAgentInfo.os.name] || 'Unknown';
  const osVersion = userAgentInfo.os.version;

  axios.defaults.headers.common['X-IT-APP-TYPE'] = 'web';
  axios.defaults.headers.common['X-IT-OS'] = operatingSystem;
  axios.defaults.headers.common['X-IT-OS-VERSION'] = osVersion;

  setIsSafari(userAgentInfo);
}

// Set custom headers on app startup
setCustomHeaders();

// Create axios instance with base configuration
const config = {
  baseURL: import.meta.env.VITE_BASEURL.replace('/api', '/v2'),
  // timeout: 60 * 1000, // Timeout (optional)
  // withCredentials: true, // For cross-site Access-Control (optional)
};

const _axios = axios.create(config);

// Add request interceptor to set additional headers
_axios.interceptors.request.use(
  (config) => {
    config.headers['User-TZ'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const token = localStorage.getItem('token');
    if (token !== null) {
      config.headers.Authorization = `JWT ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add shorthand methods for axios
for (const method of ['request', 'delete', 'get', 'head', 'options', 'post', 'put', 'patch']) {
  _axios[`$${method}`] = function() {
    return this[method]
      .apply(this, arguments)
      .then((res) => res?.data?.data); // Extract `data.data` from response
  };
}

// Define the plugin
const AxiosPlugin = {
  install(app, { store }) {
    // Attach axios to the global properties for usage in components
    app.config.globalProperties.axios = _axios;
    app.config.globalProperties.$axios = _axios;
    store.$axios = _axios;
  },
};

// Export the plugin for use in `app.use(...)`
export default AxiosPlugin;
